export function ctaCopyToConnect(shortName) {
  return shortName ? `Connect ${shortName}` : "Connect"
}

export function storageIdentifier(appletSlug, sessionId) {
  return `connectionId-${appletSlug}-${sessionId}`
}
